import React from "react";

import {
  BreadcrumbCurrent,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbNav,
} from "./Breadcrumbs.styles";

export interface BreadcrumbItemData {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItemData[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => (
  <BreadcrumbNav aria-label="Хлебные крошки">
    <BreadcrumbList>
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1 || !item.to;
        return (
          <BreadcrumbItem key={`${item.to || "current"}-${index}`}>
            {isCurrent ? (
              <BreadcrumbCurrent aria-current="page" title={item.label}>
                {item.label}
              </BreadcrumbCurrent>
            ) : (
              <BreadcrumbLink to={item.to!} title={item.label}>
                {item.label}
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        );
      })}
    </BreadcrumbList>
  </BreadcrumbNav>
);

export default Breadcrumbs;
